import { useUserRoles } from '@anytag/auth';
import { Form } from '@anytag/shared-atoms';
import { EggCampaignFormSchema } from './schema';
import { Template } from './Template';
import { EngagementCampaignFormProps, EngagementCampaignFormValues } from './types';
import { defaultEngagementCampaignFormValues } from './utils';

export const EngagementCampaignForm = ({
  onSubmit,
  defaultValues = defaultEngagementCampaignFormValues
}: EngagementCampaignFormProps) => {
  const { isAdminStaff } = useUserRoles();

  return (
    <Form.Provider<EngagementCampaignFormValues>
      onSubmit={onSubmit}
      defaultValues={{ ...defaultValues, isAdminStaff }}
      zodSchema={EggCampaignFormSchema}
    >
      <Template />
    </Form.Provider>
  );
};

export * from './types';
export {
  formatEngagementFormVariables,
  defaultEngagementCampaignFormValues,
  getDefaultEngagementCampaignFormValues
} from './utils';
